import React from 'react';
import { ArrowRight, BookOpenCheck, ClipboardList, Layers3, Microscope } from 'lucide-react';
import { Button } from '../ui/button';
import { peptidePositioningData, siteConfig } from '../../data/mock';

const pillarIcons = [Layers3, BookOpenCheck, ClipboardList];

const PeptidePositioningSection = () => {
  return (
    <section className="relative overflow-hidden bg-zinc-950 px-6 py-20 lg:py-28">
      <div className="absolute inset-0">
        <div className="absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-[#4FC3F7]/10 blur-[140px]" />
      </div>

      <div className="relative mx-auto max-w-6xl">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#4FC3F7]/20 bg-[#4FC3F7]/10 px-4 py-2 text-sm font-semibold text-[#4FC3F7]">
            <Microscope className="h-4 w-4" />
            {peptidePositioningData.badge}
          </div>
          <h2 className="mb-5 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            {peptidePositioningData.title}
          </h2>
          <p className="text-base leading-relaxed text-zinc-400 sm:text-lg">
            {peptidePositioningData.description}
          </p>
        </div>

        <div className="mb-12 grid gap-5 md:grid-cols-3">
          {peptidePositioningData.pillars.map((pillar, index) => {
            const Icon = pillarIcons[index];
            return (
              <article key={pillar.title} className="rounded-3xl border border-zinc-800/70 bg-zinc-900/50 p-6 backdrop-blur-sm">
                <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl border border-[#4FC3F7]/20 bg-[#4FC3F7]/10">
                  <Icon className="h-5 w-5 text-[#4FC3F7]" />
                </div>
                <h3 className="mb-3 text-xl font-bold text-white">{pillar.title}</h3>
                <p className="text-sm leading-relaxed text-zinc-400">{pillar.description}</p>
              </article>
            );
          })}
        </div>

        <div className="rounded-3xl border border-zinc-700/70 bg-[#121212]/90 p-6 sm:p-8">
          <div className="flex flex-col items-center justify-between gap-6 lg:flex-row">
            <div className="max-w-xl text-center lg:text-left">
              <h3 className="mb-2 text-xl font-bold text-white">Erst verstehen, dann verantwortlich entscheiden.</h3>
              <p className="text-sm leading-relaxed text-zinc-300 sm:text-base">
                Auf YouTube erklärt Arseni Peptid-Themen verständlich. Wenn du noch Orientierung suchst, ist das der beste Startpunkt.
              </p>
            </div>
            <div className="flex w-full flex-col items-center gap-3 sm:w-auto lg:items-end">
              <Button asChild className="w-full bg-[#4FC3F7] font-bold text-black hover:bg-[#3AAFDF] sm:w-auto">
                <a href={siteConfig.youtubeUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                  {peptidePositioningData.youtubeCta}
                  <ArrowRight className="h-4 w-4" />
                </a>
              </Button>
              <div className="flex flex-col items-center gap-1.5 text-center lg:items-end lg:text-right">
                <span className="text-sm text-zinc-400">{peptidePositioningData.shopPrompt}</span>
                <a
                  href={siteConfig.shopUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-base font-semibold text-white underline decoration-zinc-500 underline-offset-4 transition-colors hover:text-[#4FC3F7]"
                >
                  {peptidePositioningData.shopCta}
                  <ArrowRight className="h-4 w-4" />
                </a>
                <span className="text-sm font-medium text-zinc-300">{peptidePositioningData.shopNote}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PeptidePositioningSection;
